module.exports = __webpack_public_path__ + "static/logo-tpg-97c816c3da0917db10383a4b41487eb8.png";